import type { TileLayerConfig } from "./types";

export const cloudsLayerConfig = {
    layerName: "clouds",
    layerType: "tile",
    dataSources: {
        eu: {
            nearcast: `/maps/combined/precipitation_clouds/ncast/eu/tiles`,
            forecast: `/maps/combined/precipitation_clouds/fcast/status/{latitude}/{longitude}`,
        },
        us: {
            nearcast: `/maps/combined/precipitation_clouds/ncast/us/tiles`,
            forecast: `/maps/combined/precipitation_clouds/fcast/us/tiles`,
        },
    },
    dataSourcesChannels: {
        permanentlyUnavailable: {
            category: 0,
            colorStops: [],
        },
        temporaryUnavailable: {
            category: 1,
            colorStops: [],
        },
        cloudsOverRain: {
            category: 254,
            colorStops: [
                {
                    value: 1,
                    color: [255, 255, 255, 0],
                    descriptionTranslationKey: "clouds.clear",
                },
                {
                    value: 12.5,
                    color: [255, 255, 255, 31.8],
                    descriptionTranslationKey: "clouds.mostlyClear",
                },
                {
                    value: 25,
                    color: [255, 255, 255, 63.6],
                    descriptionTranslationKey: "clouds.bright",
                },
                {
                    value: 37.5,
                    color: [255, 255, 255, 95.4],
                    descriptionTranslationKey: "clouds.lightlyCloudy",
                },
                {
                    value: 50,
                    color: [255, 255, 255, 127.2],
                    descriptionTranslationKey: "clouds.partiallyCloudy",
                },
                {
                    value: 62.5,
                    color: [255, 255, 255, 159],
                    descriptionTranslationKey: "clouds.mostlyCloudy",
                },
                {
                    value: 75,
                    color: [255, 255, 255, 190.8],
                    descriptionTranslationKey: "clouds.stronglyCloudy",
                },
                {
                    value: 87.5,
                    color: [255, 255, 255, 222.6],
                    descriptionTranslationKey: "clouds.almostCovered",
                },
                {
                    value: 100,
                    color: [255, 255, 255, 255],
                    descriptionTranslationKey: "clouds.overcast",
                },
                {
                    value: 100.01,
                    color: [0, 0, 0, 0],
                    treatAsZeroValueStop: true,
                },
                {
                    value: 255,
                    color: [0, 0, 0, 0],
                    treatAsZeroValueStop: true,
                },
            ],
        },
        cloudsOverSnow: {
            category: 255,
            colorStops: [
                {
                    value: 1,
                    color: [255, 255, 255, 0],
                    descriptionTranslationKey: "clouds.clear",
                    treatAsZeroValueStop: true,
                },
                {
                    value: 12.5,
                    color: [255, 255, 255, 31.8],
                    descriptionTranslationKey: "clouds.mostlyClear",
                },
                {
                    value: 25,
                    color: [255, 255, 255, 63.6],
                    descriptionTranslationKey: "clouds.bright",
                },
                {
                    value: 37.5,
                    color: [255, 255, 255, 95.4],
                    descriptionTranslationKey: "clouds.lightlyCloudy",
                },
                {
                    value: 50,
                    color: [255, 255, 255, 127.2],
                    descriptionTranslationKey: "clouds.partiallyCloudy",
                },
                {
                    value: 62.5,
                    color: [255, 255, 255, 159],
                    descriptionTranslationKey: "clouds.mostlyCloudy",
                },
                {
                    value: 75,
                    color: [255, 255, 255, 190.8],
                    descriptionTranslationKey: "clouds.stronglyCloudy",
                },
                {
                    value: 87.5,
                    color: [255, 255, 255, 222.6],
                    descriptionTranslationKey: "clouds.almostCovered",
                },
                {
                    value: 100,
                    color: [255, 255, 255, 255],
                    descriptionTranslationKey: "clouds.overcast",
                },
                {
                    value: 100.01,
                    color: [0, 0, 0, 0],
                    treatAsZeroValueStop: true,
                },
                {
                    value: 255,
                    color: [0, 0, 0, 0],
                    treatAsZeroValueStop: true,
                },
            ],
        },
    },
} as const satisfies TileLayerConfig;
